export enum ActiveProtectionSensitivity {
	Low = 2,
	Medium = 1,
	High = 0,
}
